import { ErrorToast, SuccessToast } from "../components/toastify";
import { AxiosPostMethod } from "../helpers/customAxios";
import { setShowPreloader } from "../store/activePage";
import HandleLogout from "./handleLogout";

const handleUpdateEventPayment = async (values, dispatch) => {
  console.log("[ReferralBonus] update payment payload", values);
  dispatch(setShowPreloader(true));
  const updateEventPayment = await AxiosPostMethod(
    "org/update-payment",
    values,
    false
  );
  if (updateEventPayment?.status === 200) {
    SuccessToast("Event Payment Updated Successfully");
  } else {
    if (updateEventPayment?.status === 401) HandleLogout();
    ErrorToast("Something Went wrong. Please try again later");
  }
  dispatch(setShowPreloader(false));
  return updateEventPayment;
};

export default handleUpdateEventPayment;
